import axios from 'axios';
const url = '/usuarios/persona';

export default {
  update(id, data) {
    return axios.put(`${url}/${id}`, data); // Usar PUT o PATCH según corresponda
  },
};